(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artisan-product-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('.artisan-reviews-slider__toggle');if(!button)return;const section=button.closest('.artisan-reviews-slider');const paused=section.toggleAttribute('data-paused');button.setAttribute('aria-pressed',String(paused));button.textContent=paused?button.dataset.play:button.dataset.pause;});

document.addEventListener('click',event=>{
 const button=event.target.closest('[data-review-step]');if(!button)return;
 const section=button.closest('.artisan-product-reviews');
 const viewport=section.querySelector('.artisan-reviews-slider__viewport')||section.querySelector('.artisan-product-reviews__cards');
 const card=viewport.querySelector('article');if(!card)return;
 viewport.scrollBy({left:Number(button.dataset.reviewStep)*(card.getBoundingClientRect().width+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-product-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('pointerover',event=>{if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;const panel=event.target.closest('.artisan-story__disclosure');if(panel&&!panel.contains(event.relatedTarget)){panel.open=true;panel.dataset.hoverOpened='true';}});
document.addEventListener('pointerout',event=>{const panel=event.target.closest('.artisan-story__disclosure');if(panel&&!panel.contains(event.relatedTarget)&&panel.dataset.hoverOpened&&!panel.contains(document.activeElement)){panel.open=false;delete panel.dataset.hoverOpened;}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
